const deriveLinks = (vertical, copyData, combinedVerticals, data) => {
    if (combinedVerticals) {
        return {
            linkOne: copyData.vertical_k12_link,
            textOne: copyData.vertical_k12,
            imageOne: data.k12_circle.childImageSharp.fixed,
            linkTwo: copyData.vertical_hed_link,
            textTwo: copyData.vertical_hed,
            imageTwo: data.hed_circle.childImageSharp.fixed,
            linkThree: copyData.vertical_business_link,
            textThree: copyData.vertical_business,
            imageThree: data.business_circle.childImageSharp.fixed
        };
    }
    if (copyData.market.toString() === "LA") {
        return {
            linkOne: copyData.vertical_business_link,
            textOne: copyData.vertical_business,
            imageOne: data.business_circle.childImageSharp.fixed,
            linkTwo: copyData.vertical_k12_link,
            textTwo: copyData.vertical_k12,
            imageTwo: data.k12_circle.childImageSharp.fixed,
            linkThree: copyData.vertical_hed_link,
            textThree: copyData.vertical_hed,
            imageThree: data.hed_circle.childImageSharp.fixed
        };
    }
    if (copyData.market.toString() === "BR") {
        return {
            linkOne: copyData.vertical_business_link,
            textOne: copyData.vertical_business,
            imageOne: data.business_circle.childImageSharp.fixed,
            linkTwo: copyData.vertical_k12_link,
            textTwo: copyData.vertical_k12,
            imageTwo: data.k12_circle.childImageSharp.fixed,
            linkThree: copyData.vertical_hed_link,
            textThree: copyData.vertical_hed,
            imageThree: data.hed_circle.childImageSharp.fixed
        };
    }
    switch (vertical) {
        case "k12":
            return {
                linkOne: copyData.vertical_pub_link,
                textOne: copyData.vertical_pub,
                imageOne: data.pub_circle.childImageSharp.fixed,
                linkTwo: copyData.vertical_business_link,
                textTwo: copyData.vertical_business,
                imageTwo: data.business_circle.childImageSharp.fixed,
                linkThree: copyData.vertical_hed_link,
                textThree: copyData.vertical_hed,
                imageThree: data.hed_circle.childImageSharp.fixed
            };
        case "hed":
            return {
                linkOne: copyData.vertical_pub_link,
                textOne: copyData.vertical_pub,
                imageOne: data.pub_circle.childImageSharp.fixed,
                linkTwo: copyData.vertical_business_link,
                textTwo: copyData.vertical_business,
                imageTwo: data.business_circle.childImageSharp.fixed,
                linkThree: copyData.vertical_k12_link,
                textThree: copyData.vertical_k12,
                imageThree: data.k12_circle.childImageSharp.fixed
            };
        case "pubsec":
            return {
                linkOne: copyData.vertical_business_link,
                textOne: copyData.vertical_business,
                imageOne: data.business_circle.childImageSharp.fixed,
                linkTwo: copyData.vertical_k12_link,
                textTwo: copyData.vertical_k12,
                imageTwo: data.k12_circle.childImageSharp.fixed,
                linkThree: copyData.vertical_hed_link,
                textThree: copyData.vertical_hed,
                imageThree: data.hed_circle.childImageSharp.fixed
            };
        default:
            return {
                linkOne: copyData.vertical_pub_link,
                textOne: copyData.vertical_pub,
                imageOne: data.pub_circle.childImageSharp.fixed,
                linkTwo: copyData.vertical_k12_link,
                textTwo: copyData.vertical_k12,
                imageTwo: data.k12_circle.childImageSharp.fixed,
                linkThree: copyData.vertical_hed_link,
                textThree: copyData.vertical_hed,
                imageThree: data.hed_circle.childImageSharp.fixed
            };
    }
};

module.exports = { deriveLinks };
